export const GRID_SCHEMA = {
    ROWS: 'rows',
    COLUMNS: 'columns',
    GUTTER: 'gutter',
}
